import React, { useState } from 'react';
import { apiService } from '../../../../services/api';
import { CreateOpportunityStatusData } from '../../../../types/opportunityStatus';
import { toast } from 'react-toastify';
import './QuickStatusForm.css';

interface QuickStatusFormProps {
  onSuccess: (newStatus: any) => void;
  onCancel: () => void;
}

const QuickStatusForm: React.FC<QuickStatusFormProps> = ({
  onSuccess,
  onCancel
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [newStatus, setNewStatus] = useState<CreateOpportunityStatusData>({
    nome: '',
    descricao: ''
  });

  const handleSubmit = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    // Validação ANTES de setar loading
    if (!newStatus.nome.trim()) {
      toast.error('O nome do status é obrigatório');
      return;
    }

    try {
      setIsSubmitting(true);

      const response = await apiService.createStatusOportunidade(newStatus);

      if (response && response.data) {
        // Limpar form antes de chamar onSuccess
        setNewStatus({ nome: '', descricao: '' });

        // Chamar callback de sucesso (o toast será mostrado no parent)
        onSuccess(response.data);
      }
    } catch (error) {
      console.error('Erro ao criar status:', error);
      toast.error('Erro ao criar status');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="quick-status-form-wrapper">
      <div className="alert alert-info d-flex align-items-center mb-3">
        <i className="ti ti-info-circle me-2"></i>
        <span>Cadastro rápido - Adicione um novo status de oportunidade</span>
      </div>

      <div className="row">
        {/* Nome do Status */}
        <div className="col-12 mb-3">
          <label className="form-label">
            Nome do Status <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            value={newStatus.nome}
            onChange={(e) => setNewStatus(prev => ({ ...prev, nome: e.target.value }))}
            placeholder="Ex: Análise Jurídica, Aguardando Aprovação"
            autoFocus
          />
        </div>

        {/* Descrição */}
        <div className="col-12 mb-3">
          <label className="form-label">Descrição</label>
          <textarea
            className="form-control"
            rows={3}
            value={newStatus.descricao}
            onChange={(e) => setNewStatus(prev => ({ ...prev, descricao: e.target.value }))}
            placeholder="Detalhes opcionais sobre este status..."
          />
        </div>

        {/* Botões de Ação */}
        <div className="col-12">
          <div className="d-flex gap-2 justify-content-end pt-2 border-top">
            <button
              type="button"
              className="btn btn-light"
              onClick={onCancel}
              disabled={isSubmitting}
            >
              <i className="ti ti-x me-1"></i>
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Salvando...
                </>
              ) : (
                <>
                  <i className="ti ti-check me-1"></i>
                  Salvar Status
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickStatusForm;
